define('plugin/promotion/PromotionPlugin',['require','backbone','underscore','lib/plugin/PluginAbstract','plugin/promotion/controller/PromotionController','plugin/promotion/collection/PromotionCollection','plugin/promotion/model/PromotionModel','plugin/promotion/view/PromotionCodeInputView','plugin/promotion/view/PromotionInvoiceInstanceListView','plugin/promotion/view/PromotionServiceBadgeView','plugin/promotion/view/PromotionModuleListView','handlebars','view/helper/TemplatePrecompiled','lib/AppRouter'],function (require) {

    var Backbone = require('backbone');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var PromotionController = require('plugin/promotion/controller/PromotionController');
    var PromotionCollection = require('plugin/promotion/collection/PromotionCollection');
    var PromotionModel = require('plugin/promotion/model/PromotionModel');
    var PromotionCodeInputView = require('plugin/promotion/view/PromotionCodeInputView');
    var PromotionInvoiceInstanceListView = require('plugin/promotion/view/PromotionInvoiceInstanceListView');
    var PromotionServiceBadgeView = require('plugin/promotion/view/PromotionServiceBadgeView');
    var PromotionModuleListView = require('plugin/promotion/view/PromotionModuleListView');
    var Handlebars = require('handlebars');
    var templateFor = require('view/helper/TemplatePrecompiled').templateFor;
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _collection: null,
        bookingModel: null,
        promotionModel: null,

        _promotionModuleRegions: {
            promotionModule: '#sb_promotion_module',
        },

        serviceRegions: {
            promotionBadge: '.sb_promotion_badge'
        },

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initCollection();
            this.initRoutes();
            this.initTemplateHelpers();
            this.subscribeInvoiceViewEvents();
            this.subscribeServiceViewEvents();
        },

        /**
         * Initializes collection
         */
        initCollection: function () {
            this._collection = new PromotionCollection();
        },

        /**
         * On step manager inits, add events
         */
        initStepManagerEvents: function () {
            this.bookingModel = this._stepManager.getBookingModel();
            this.initPredefinedPromocode();
        },

        /**
         * Initialize plugin modules
         */
        initModules: function (layout) {
            _.each(this._promotionModuleRegions, function (selector, promotionRegion) {
                layout.addRegion(promotionRegion, selector);
            });

            if (layout.promotionModule.$el.length && Config.getInstance().getOption('promotion_has_active_gift_cards')) {
                layout.promotionModule.show(new PromotionModuleListView({
                    collection: this._collection
                }));
                this._collection.load();
            }
        },

        initPredefinedPromocode: function () {
            var code = Config.getInstance().getOption('apply_promo_code');
            if (code) {
                this.promotionModel = new PromotionModel();
                this.promotionModel.fetch({
                    data: {
                        code: code
                    },
                    success: _.bind(function () {
                        this.bookingModel.set('promotion_to_apply', this.promotionModel.toJSON());
                    }, this)
                });
            }
        },

        /**
         * Subscribe to show promotion view
         */
        subscribeServiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('step:item').vent.on(
                'render', _.bind(this.onAddChild, this)
            );
        },

        onAddChild: function (event) {
            if (event.stepItem !== 'service') {
                return;
            }

            event.view.listenTo(this.promotionModel, 'sync', event.view.render);

            var serviceModel = event.model;
            if (!this.promotionModel) {
                return;
            }
            if (!this.promotionModel.get('affect_services')) {
                return;
            }
            if (this.promotionModel.get('service_restrictions').length > 0 && this.promotionModel.get('service_restrictions').indexOf(parseInt(serviceModel.id)) === -1) {
                return;
            }

            this._initServiceRegions(event.view);
            // do not show promotion badge on services for a while
            /*event.view.promotionBadge.show(new PromotionServiceBadgeView({
                model: this.promotionModel
            }));*/
        },

        _initServiceRegions: function (view) {
            _.each(this.serviceRegions, function (selector, region) {
                view.addRegion(region, {
                    'el': selector,
                    'allowMissingEl': true
                });
            });
        },

        /**
         * Subscribe to show promotion view
         */
        subscribeInvoiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('invoice:layout').vent.on(
                'show', _.bind(this.onInvoiceLayoutShow, this)
            );
        },

        /**
         * Display promotion code input
         */
        onInvoiceLayoutShow: function (data) {
            var layout = data.view;
            var model = data.model;

            if (data.paymentAllowed && this._allowToShowDiscount(model)) {
                var view = new PromotionCodeInputView({
                    model: model
                });

                if (Config.getInstance().getOption('apply_promo_code') && (!model.get('promotion_instances') || !model.get('promotion_instances').length)) {
                    model.applyPromoCode(Config.getInstance().getOption('apply_promo_code'));
                }

                this.listenTo(view, 'apply:promo:code', this.applyPromoCode);

                layout.getPromotionCodeRegion().show(view);
            }

            var listView = new PromotionInvoiceInstanceListView({
                model: model,
                collection: model.get('promotion_instances'),
                allowEdit: data.paymentAllowed && model.get('status') === 'new'
            });

            this.listenTo(listView, 'remove:promo:code', this.removePromoCode);

            layout.getPromotionListRegion().show(listView);
        },

        _allowToShowDiscount: function (model) {
            var allow = false;
            if (model.get('status') !== 'new') {
                return false;
            }
            if (model.get('rest_amount') > 0) {
                return false;
            }
            model.get('lines').each(function (model) {
                if (model.get('type') !== 'promotion') {
                    allow = true;
                }
            }, this);

            return allow;
        },

        /**
         * Applies promotion code
         *
         * @param model
         * @param code
         */
        applyPromoCode: function (model, code) {
            model.applyPromoCode(code);
        },

        /**
         * Remove promotion code
         *
         * @param invoiceModel
         * @param instanceModel
         */
        removePromoCode: function (invoiceModel, instanceModel) {
            invoiceModel.removePromoCode(instanceModel.get('id'));
        },

        /**
         * Inits promotion routes
         */
        initRoutes: function () {
            var promotionRouter = new AppRouter({
                appRoutes: {
                    'gift-card(/)': 'index',
                    'gift-card/buy/:id(/)': 'buyWithClientInfo',
                    'gift-card/buy/:id(/)bonus(/)': 'buyWithClientInfoByBonus',
                    'gift-card/my(/highlight/:id)(/)': 'my',
                    'gift-card/view/:id/:code(/)': 'view'
                },
                menuItem: 'gift-card',
                controller: new PromotionController({
                    app: this.getOption('app'),
                    collection: this._collection,
                    clientModel: this.getOption('clientModel')
                })
            });
        },

        initTemplateHelpers: function () {
            Handlebars.registerPartial('promotion_header_part', templateFor('#promotion_header_part'));
        }

    });

});
